// extracted by mini-css-extract-plugin
export default {"wrap":"IG-z","fullWidth":"JG-z","hideOnDesktop":"KG-z","content":"LG-z","hasOpenedNav":"MG-z","crumbsList":"NG-z","dropdownsWrap":"OG-z"};